module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-sharp-regular-400.ttf";